var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.wrapperClass},_vm._l((_vm.numberOfSkeletonLoaders),function(i){return _c('skeleton-loader',{key:i,attrs:{"loader-type":_vm.loaderType,"detailed-loader":!_vm.horizontal && !_vm.isDesktop}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }